var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQualityStandard32 = function SvgQualityStandard32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.007c0 1.755-2.411 3.012-3.04 4.535-.657 1.579.133 4.166-1.071 5.36-1.204 1.193-3.78.4-5.358 1.054C19.009 27.588 17.752 30 16 30c-1.75 0-3.01-2.412-4.532-3.044-1.575-.654-4.165.135-5.358-1.055-1.193-1.19-.4-3.776-1.071-5.36C4.407 19.02 2 17.762 2 16.008s2.407-3.009 3.04-4.53c.653-1.58-.136-4.167 1.071-5.36 1.208-1.194 3.78-.4 5.358-1.073C12.991 4.412 14.252 2 16.002 2c1.75 0 3.007 2.412 4.529 3.044 1.579.654 4.168-.135 5.358 1.072 1.19 1.208.396 3.777 1.071 5.36.629 1.53 3.04 2.78 3.04 4.531Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.312 13.615 1.194-2.27a.663.663 0 0 1 .24-.253.638.638 0 0 1 .899.252l1.24 2.29a.666.666 0 0 0 .429.32l2.171.475a.64.64 0 0 1 .296.154.673.673 0 0 1 .208.623.68.68 0 0 1-.14.309l-1.552 1.916a.67.67 0 0 0-.149.501l.24 2.328a.685.685 0 0 1-.262.61.638.638 0 0 1-.645.073l-2.15-.958a.647.647 0 0 0-.52 0l-2.135.958a.635.635 0 0 1-.652-.076.687.687 0 0 1-.258-.62l.274-2.29a.685.685 0 0 0-.165-.526l-1.709-1.967a.679.679 0 0 1-.13-.668.672.672 0 0 1 .194-.291.643.643 0 0 1 .311-.15l2.287-.402a.669.669 0 0 0 .484-.338v0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgQualityStandard32;